import { render, staticRenderFns } from "./plugin-home-invest-button.vue?vue&type=template&id=567717ac&scoped=true&"
import script from "./plugin-home-invest-button.vue?vue&type=script&lang=js&"
export * from "./plugin-home-invest-button.vue?vue&type=script&lang=js&"
import style0 from "./plugin-home-invest-button.vue?vue&type=style&index=0&id=567717ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567717ac",
  null
  
)

export default component.exports